<template lang="pug">
include ../../Bemto
+b.telegram-prompt
  +b.P.text.--size-sm {{ _('Всі пропозиції щодо зйомок будуть надходити в чат-бот.') }}
  +b.SPAN.text.--weight-bold.--size-sm.rules-link {{ _('Підписка на чат-бот обовʼязкова.') }}
  hr
  row(
    :align="'center'"
    :justify="'center'"
  )
    cell
      +b.APP-ICON.text.--color-light-blue.--size-xs(
        name="icon-telegram"
      )
    cell
      +b.A.rules-link.text.--color-light-blue.--transform-upper.--decoration-under.--space-lg.--size-xs.--pointer(
        target='_blank'
        :href='BOT_LINK'
      ) {{ _('ПІДПИСАТИСЯ НА ЧАТ-БОТА') }}
</template>

<script>
export default {
  name: 'telegram-prompt',
  data() {
    return {
      BOT_LINK: window.BOT_LINK,
    }
  },
}
</script>
